import { Vue, Component } from 'vue-property-decorator';
import { createAxiosInstance } from '../services/base.service';
import { AxiosInstance } from 'axios';

@Component({})
export default class BaseServiceMixin extends Vue {
  protected axiosInstance!: AxiosInstance;

  public created() {
    this.axiosInstance = createAxiosInstance();
  }
}
